import { Reply } from 'lucide-react';

export default function ReplyCard(props) {
    const companyName = props?.company?.length > 0 ? props.company : 'They';

    return (
        <div className="mt-4 w-full">
            <div className="flex w-full items-start gap-3 rounded-lg border border-blue-300 bg-white p-4 text-blue-900">
                <Reply className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" />
                <div className="flex-1">
                    <h2 className="mb-2 text-base font-semibold text-slate-700">{companyName} replied</h2>
                    <p
                        className="text-sm leading-relaxed text-slate-700"
                        dangerouslySetInnerHTML={{
                            __html: props?.reply?.text?.replace(/(\r\n|\r|\n)/g, '<br />'),
                        }}
                    />
                </div>
            </div>
        </div>
    );
}
